export const hideSplashScreen = () => {
  const splashscreenDefault = document.querySelector('#default-splashscreen');
  if (splashscreenDefault) splashscreenDefault.classList.remove('default-splashscreen--visible');

  const splashscreenWisniowski = document.querySelector('#wisniowski-splashscreen');
  if (splashscreenWisniowski) splashscreenWisniowski.classList.remove('wisniowski-splashscreen--visible');
};
